<template>
  <div class="workoutActionLegend workoutActionBindingCols" role="note" aria-label="动作绑定字段说明">
    <div class="workoutActionLegend__row workoutActionLegend__row--labels">
      <span class="workoutActionLegend__label">{{ fieldLabels.videoRepeatCount }}</span>
      <div class="workoutActionLegend__separator" aria-hidden="true" />
      <span class="workoutActionLegend__label">{{ fieldLabels.configuredPlaySeconds }}</span>
      <div class="workoutActionLegend__separator" aria-hidden="true" />
      <span class="workoutActionLegend__label">{{ fieldLabels.restSeconds }}</span>
    </div>
    <div class="workoutActionLegend__row workoutActionLegend__row--tips">
      <span class="workoutActionLegend__tip">{{ bindingTips.videoRepeatCount }}</span>
      <div class="workoutActionLegend__separator" aria-hidden="true" />
      <span class="workoutActionLegend__tip">{{ bindingTips.configuredPlaySeconds }}</span>
      <div class="workoutActionLegend__separator" aria-hidden="true" />
      <span class="workoutActionLegend__tip">{{ bindingTips.restSeconds }}</span>
    </div>
  </div>
</template>

<script>
import { WORKOUT_BINDING_FIELD_TIPS } from './workoutFormConstants'
import './workoutCollectionBinding.css'

/**
 * 动作区头部底栏：两行三列说明（第 1 行字段名，第 2 行 tip），仅占一次，不随每条动作重复。
 */
export default {
  name: 'WorkoutActionBindingLegend',
  props: {
    fieldLabels: { type: Object, required: true },
    bindingTips: {
      type: Object,
      default: () => WORKOUT_BINDING_FIELD_TIPS,
    },
  },
}
</script>

<style scoped>
.workoutActionLegend {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.workoutActionLegend__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 1px minmax(0, 1fr) 1px minmax(0, 1fr);
  column-gap: var(--workout-binding-col-gap, 32px);
  align-items: start;
  width: 100%;
}

.workoutActionLegend__separator {
  width: 1px;
  min-height: 100%;
  background: var(--link-line-strong, #e5dfd6);
  justify-self: center;
}

.workoutActionLegend__label {
  font-size: 11px;
  font-weight: var(--link-font-semibold);
  color: var(--link-ink-muted);
  line-height: 1.3;
  text-align: center;
}

.workoutActionLegend__tip {
  font-size: 10px;
  line-height: 1.4;
  color: var(--link-ink-muted);
  text-align: center;
  white-space: normal;
}
</style>
